import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CapturumRadioComponent } from './radio.component';
import { RadioButtonModule } from 'primeng/radiobutton';
import { CapturumSharedModule } from '@capturum/ui/api';
import { FormsModule } from '@angular/forms';

@NgModule({
  declarations: [
    CapturumRadioComponent
  ],
  exports: [
    CapturumRadioComponent
  ],
  imports: [
    CommonModule,
    FormsModule,
    RadioButtonModule,
    CapturumSharedModule
  ]
})
export class CapturumRadioModule {
}
